import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { DigitalCourseEffects } from './digital-course.effects';
import { digitalCourseReducer } from './digital-course.reducer';
import {
  DigitalCourseAdvantageResolver,
  DigitalCourseResolver,
  DigitalCourseStoreService,
} from './services';
import { digitalCourseFeatureKey } from './digital-course.state';

@NgModule({
  imports: [
    StoreModule.forFeature(digitalCourseFeatureKey, digitalCourseReducer),
    EffectsModule.forFeature([DigitalCourseEffects]),
  ],
  providers: [
    DigitalCourseStoreService,
    DigitalCourseResolver,
    DigitalCourseAdvantageResolver,
  ],
})
export class DigitalCourseStoreModule {}
